// tslint:disable-next-line:ter-max-len
const PHONE_NUMBER_REGEX = /^\d+$/;

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  return PHONE_NUMBER_REGEX.test(phoneNumber);
};
